<template>
    <div>
        <toggle-collapse>
            <b-col cols="12">

                <b-form-group :label="$t('owners')" label-for="vi-owenrs-id">
                    <v-select multiple :close-on-select="false" v-model="owners"
                        :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                        :options="[{ name: $t('all'), id: 'all' }, ...ownersOptions]" :reduce="d => d.id"
                        v-on:input="refilterContractsByOwner()" />

                </b-form-group>
            </b-col>

        </toggle-collapse>

        <b-card style="position: relative">

            <div v-if="loading" class="loading_page">
                <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
            </div>

            <b-form @submit.prevent="getReport" class="">

                <b-row class="mt-2">

                    <!-- Contracts  -->
                    <b-col cols="12">
                        <b-form-group :label="$t('Contracts')" label-for="vi-Contracts-id">
                            <v-select multiple :close-on-select="false" v-model="request.contracts"
                                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                                :options="[{ name: $t('all'), id: 'all' }, ...contractsOptions]" :reduce="d => d.id" />
                            <small v-if="errors && ('contracts' in errors)" class="text-danger">
                                {{ $t(errors['contracts'][0]) }}
                            </small>
                        </b-form-group>
                    </b-col>



                    <b-col v-if="report_type == 'report'" md="12" sm="12">
                        <!-- report range date -->
                        <b-form-group :label="$t('Select Year and Month')" label-for="report-date" :state="null">
                            <flat-pickr v-model="request.month" :state="null" class="form-control"
                                :config="{ ...pickerOptions }" placeholder="YYYY-MM-DD"
                                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" />

                            <small v-if="errors && ('month' in errors)" class="text-danger">
                                {{ $t(errors['month'][0]) }}
                            </small>
                        </b-form-group>
                    </b-col>

                </b-row>
                <b-row>

                    <b-col cols="4 mt-3">
                        <b-form-group :label="$t('hours')" label-for="vi-hours-id">
                        </b-form-group>


                    </b-col>

                    <b-col cols="4">

                        <b-form-group :label="$t('comperation operator')" label-for="vi-hours-id">
                            <v-select v-model="hoursOperator" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                                :getOptionLabel="d => d.name"
                                :options="hourSearchoperations.map(i => ({ id: i.id, name: $t(i.name) }))"
                                :reduce="d => d.id" />
                            <small v-if="errors && ('dependsOn_duration_operator' in errors)" class="text-danger">
                                {{ $t(errors['dependsOn_duration_operator'][0]) }}
                            </small>
                        </b-form-group>

                    </b-col>
                    <b-col cols="4">
                        <b-form-group :label="$t('hours')" label-for="hours">
                            <cleave id="dependsOn_duration" v-model="hours" class="form-control" :raw="false" :options="{
                                numeral: true,
                                numeralThousandsGroupStyle: 'thousand',
                            }" placeholder="10,000" />
                        </b-form-group>
                    </b-col>
                </b-row>



                <b-row>

                    <b-col cols="4 mt-3">
                        <b-form-group :label="$t('distance')" label-for="vi-hours-id">
                        </b-form-group>


                    </b-col>

                    <b-col cols="4">

                        <b-form-group :label="$t('comperation operator')" label-for="vi-hours-id">
                            <v-select v-model="distanceOperator"
                                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                                :options="hourSearchoperations.map(i => ({ id: i.id, name: $t(i.name) }))"
                                :reduce="d => d.id" />
                            <small v-if="errors && ('dependsOn_duration_operator' in errors)" class="text-danger">
                                {{ $t(errors['dependsOn_duration_operator'][0]) }}
                            </small>
                        </b-form-group>

                    </b-col>
                    <b-col cols="4">
                        <b-form-group :label="$t('distance')" label-for="distance">
                            <cleave id="dependsOn_duration" v-model="distance" class="form-control" :raw="false" :options="{
                                numeral: true,
                                numeralThousandsGroupStyle: 'thousand',
                            }" placeholder="10,000" />
                        </b-form-group>
                    </b-col>
                </b-row>
               

                <b-row>
                    <b-col cols="6">

                        <b-form-checkbox v-model="campLeave"  :value="1"  :unchecked-value="0">
                      {{ $t('depends on camp Leave') }}
                    
                        </b-form-checkbox>
                        <b-row>
                            <small v-if="errors && ('conditions' in errors)" class="text-danger">
                    {{ $t(errors['conditions'][0]) }}
                     </small>

                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <!-- reset and submit -->
                    <b-col v-if="report_type == 'report'" cols="12">
                        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
                            {{ $t('Get Report') }}
                        </b-button>
                    </b-col>

                    <b-col v-if="report_type == 'setting'" cols="12">
                        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="button" variant="primary" class="mr-1"
                            @click="saveDialySetting('status')">
                            {{ $t('Save Setings') }}
                        </b-button>
                    </b-col>
                </b-row>
                

            </b-form>
        </b-card>

        <div v-if="report_data">
            <DataTable :report_data="report_data" :report_fields="report_fields"
                :filter_included_fields="filter_included_fields" :request="request" :errors="errors"
                :loading="dataTableloading || loading" :getReport="getReport" :total="total" :from="from" :to="to"
                :sortData="sortData" />

        </div>


    </div>
</template>
  
<script>

import {
    BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
    BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination,
    BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref, onMounted } from '@vue/composition-api'
import ToggleCollapse from '@/views/ui/toggle-collapse/ToggleCollapse.vue'
import { ReportSetting } from '@/views/reports/ReportSettings'
import DataTable from '@/views/reports/data-table/DataTable.vue'
import 'flatpickr/dist/plugins/monthSelect/style.css';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';
import Cleave from 'vue-cleave-component'

import TotalAbsencePerMonthLogic from './logic'
import TotalAbsencePerMonthFormOptions from './form'
export default {
    name: 'DevicesAbsenceCountPerMonth',
    components: {
        BRow,
        BCard, BFormCheckboxGroup, BTable, BPagination,
        BCol, BFormRadioGroup, BFormInvalidFeedback,
        BAlert,
        BFormGroup,
        BFormInput, flatPickr,
        BFormCheckbox,
        BInputGroup,
        BInputGroupPrepend,
        BForm,
        BButton,
        BTabs,
        BCardText,
        BTab,
        vSelect,
        OrbitSpinner,

        ToggleCollapse,
        DataTable,
        Cleave

    },
    directives: {
        Ripple,
    },
    props: {
        report_type: {
            type: String,
            default: 'report'

        }
    },
    setup(props, { root, refs }) {

        const hourSearchoperations = ref([
            { id: ">", name: 'greater than' },
            { id: "<", name: "less than" },
            { id: "=", name: "equal" }

        ]);



        const rangeDate = ref('')
        const owners = ref([])
        const filter_included_fields = ['contract', 'contractor', 'absenceDays', 'absenceDevices', 'contractDevices', 'percent',];
        const report_fields = [
            {
                key: 'index',
                label: 'id',

            },
            {
                key: 'contractor',
                label: 'contractor',
                sortable: true
            },
            {
                key: 'contract',
                label: 'contract'
            },
            {
                key: 'device',
                label: 'device'
            },
           
            {
                key: 'absenceTimes',
                label: 'Absence Times'
            },
           



        ];

        const sortData = (data) => {
            sortBy.value = data.sortBy
            isSortDirDesc.value = data.isSortDirDesc
        }
        const { ownersOptions, contractsOptions, contractsOptions_orig } = TotalAbsencePerMonthFormOptions()

        const refilterContractsByOwner = () => {

            contractsOptions.value = contractsOptions_orig.value.filter((c) => owners.value.includes(c.contractor_id))
            if (owners.value.length == 0) {
                contractsOptions.value = contractsOptions_orig.value.map(c => c)
            }
        }

        const merageFilterWithRequest = (data) => {
            delete data['type']
            if (data['isSupport'] == "all") {
                delete data['isSupport']
                delete request.value.isSupport
            }
            Object.assign(request.value, data);
        }




        const tableRef = ref(null)

        const { report_data,
            request,
            hoursOperator,
            hours,
            distanceOperator,
            distance,
            campLeave,
            date, errors, loading, getReport, total, from, to, isSortDirDesc, sortBy, dataTableloading } = TotalAbsencePerMonthLogic()


        const pickerOptions = {


            plugins: [
                new monthSelectPlugin({
                    shorthand: false, //defaults to false
                    dateFormat: "F Y", //defaults to "F Y"
                    altFormat: "F Y", //defaults to "F Y"
                    theme: "light" // defaults to "light"
                })
            ]

        }
        const perPageOptions = [5, 10, 25, 50, 100]
        const report_wrapper = ref(null)

        /// here use this form ass dialy report setting
        const toaster = (msg, variant = 'success', title = 'Success') => {
            root.$root.$bvToast.toast(
                root.$i18n.t(msg), {
                title: root.$i18n.t(title),
                variant,
                solid: true,
            })
        }
        const saveDialySetting = (reportName) => {
            let setting_data = request.value;
            delete setting_data.to;
            delete setting_data.from;

            ReportSetting.setSettings(reportName, setting_data).then((res) => {
                toaster('settigs saved succeffly!!', 'success!!')
            }).catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
        }
        onMounted(() => {
            if (props.report_type == 'setting') {
                ReportSetting.getSetting('status').then((res) => {
                    request.value = res;

                })
            }
        })
        //here end of   dialy report setting
        return {
            report_data, filter_included_fields, report_fields, total, from, to, rangeDate,
            tableRef,
            getReport,
            perPageOptions,
            contractsOptions,
            ownersOptions,
            pickerOptions,
            owners,
            report_wrapper,
            request, date,
            loading,
            errors,
            merageFilterWithRequest,
            refilterContractsByOwner, refilterContractsByOwner,
            saveDialySetting,
            sortData,
            dataTableloading,
            hourSearchoperations,
            hoursOperator,
            hours,
            distanceOperator,
            distance,
            campLeave


        }

    },

}
</script>
  
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
    overflow: hidden;
    transition: .35s height;
}
</style>
  